export const NotFound = () => {
  return (
    <main style={{ padding: "1rem" }}>
      <p>The page you were looking for could not be found.</p>
    </main>
  );
};
